import {
    put,
    call,
    takeLatest
} from 'redux-saga/effects'

import fetch from '../../../api/fetch'

// import {
//     receiveGlobalList
// } from '../../actions/lists'

import * as types from '../../../constants/quote/step00'

export function* fetchPolicyCategoriesSaga() {
    try {
        yield put({ type: types.FETCH_POLICY_CATEGORIES_REQUEST })
        const response = yield call( fetch, '/policy_categories', { method: 'GET' } )
        yield put({
            type: types.FETCH_POLICY_CATEGORIES_SUCCESS,
            payload: response.policyCategories,
        })
    } catch (error) {
        yield put({
            type: types.FETCH_POLICY_CATEGORIES_FAILURE,
            payload: error,
        })
    } finally {
        yield put({ type: types.FETCH_POLICY_CATEGORIES_FULFILL })
    }
}

export function* watchFetchPolicyCategoriesSaga() {
    yield takeLatest( types.FETCH_POLICY_CATEGORIES_TRIGGER, fetchPolicyCategoriesSaga )
}

export function* fetchPolicyTypesSaga() {
    try {
        yield put({ type: types.FETCH_POLICY_TYPES_REQUEST })
        const response = yield call( fetch, '/policy_types', { method: 'GET' } )
        yield put({
            type: types.FETCH_POLICY_TYPES_SUCCESS,
            payload: response.policyTypes,
        })
    } catch (error) {
        yield put({
            type: types.FETCH_POLICY_TYPES_FAILURE,
            payload: error,
        })
    } finally {
        yield put({ type: types.FETCH_POLICY_TYPES_FULFILL })
    }
}

export function* watchFetchPolicyTypesSaga() {
    yield takeLatest( types.FETCH_POLICY_TYPES_TRIGGER, fetchPolicyTypesSaga )
}

export function* fetchCountriesSaga() {
    try {
        yield put({ type: types.FETCH_COUNTRIES_REQUEST })
        const response = yield call( fetch, '/countries', { method: 'GET' } )
        yield put({
            type: types.FETCH_COUNTRIES_SUCCESS,
            payload: response,
        })
    } catch (error) {
        yield put({
            type: types.FETCH_COUNTRIES_FAILURE,
            payload: error,
        })
    } finally {
        yield put({ type: types.FETCH_COUNTRIES_FULFILL })
    }
}

export function* watchFetchCountriesSaga() {
    yield takeLatest( types.FETCH_COUNTRIES_TRIGGER, fetchCountriesSaga )
}

export default [
    watchFetchPolicyCategoriesSaga(),
    watchFetchPolicyTypesSaga(),
    watchFetchCountriesSaga(),
]



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/sagas/quote/step00/index.ts